
  window.matchHeight = (elements) => {
    if(window.innerWidth >= 768) {
      var allHeights = [],
          i = 0;
      for(i = 0; i < elements.length; i++){
        elements[i].style.height = 'auto';
      }

      for(i = 0; i < elements.length; i++){
        var elementHeight = elements[i].clientHeight;
        allHeights.push(elementHeight);
      }
      for(i = 0; i < elements.length; i++){
        elements[i].style.height = Math.max.apply( Math, allHeights) + 'px';
      }
    } else {
      for(i = 0; i < elements.length; i++){
        elements[i].style.height = 'auto';
      }
    }
  }
